const getDefaultDashboardState = () => {
    return {
        userId: null,
        accountInfo: null,
        portfolioSummary: null,
        isLenderContractSigned: false,
        phoneNo: null,
        Name: '',
        generatedReferralCode: null,
        profileImage: '/img/profile.jpg',
        bankAccountNumber: null,
        bankIfsc: null,
        selectedItem: 'dashboard'
    }
}

export const dashboard = {
    namespaced: true,
    state: getDefaultDashboardState(),
    getters: {
        getChartDetails: (state) => {
            return {
                pendingAmount: state.accountInfo.pendingAmount / 100,
                totalAccountValue: state.accountInfo.totalAccountValue / 100,
                investedAmount: state.portfolioSummary.investmentAmount / 100,
                escrowBalance: state.accountInfo.escrowBalance / 100,
                incomeAmount: state.accountInfo.incomeAmount / 100,
                earningsTillDate: state.portfolioSummary.returnedInterest / 100,
                expectedEarning: state.portfolioSummary.expectedEarning / 100
            }
        },
        getAllPortfolios: (state) => {
            return state.portfolioSummary.portfolios
        },
        getAccountStatus: (state) => {
            return state.accountInfo.status
        },
        getAutoInvestPortfolios: (state) => {
            return state.portfolioSummary.portfolios.filter(item => item.portfolioType === 'autoInvest')
        },
        getEscrowBalance: (state) => {
            return state.accountInfo.escrowBalance / 100
        },
        getIncomeAmount: (state) => {
            return state.accountInfo.incomeAmount / 100
        },
        getSelectedItem: (state) => {
            return state.selectedItem
        },
        getAccountInfo: (state) => {
            return state.accountInfo
        }
    },
    mutations: {
        setField (state, data) {
            state[data.field] = data.value
        },
        reset (state) {
            const initialState = getDefaultDashboardState()
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key]
            })
        },
        setEscrowBalance (state, value) {
            state.accountInfo.escrowBalance = value
        },
        setIncomeAmount (state, value) {
            state.accountInfo.incomeAmount = value
        }
    },
    actions: {
        setField ({ commit }, data) {
            commit('setField', data)
        },
        setEscrowBalance ({ commit }, value) {
            commit('setEscrowBalance', value)
        },
        setIncomeAmount ({ commit }, value) {
            commit('setIncomeAmount', value)
        }
    }
}
